module.exports = __webpack_public_path__ + "static/grid-68c3e106e7c5ace645c5a7acf81d5860.png";